export function getStatusString(status) {
    if(!status) return "";

    switch (status) {
        case "CHECKINGOUT":
            return "Non inviata";
        case "PENDING":
            return "Da rispondere";
        case "ACCEPTED":
            return "Preventivo inviato";
        case "DECLINED":
            return "Richiesta rifiutata";
        case "CONFIRMED":
            return "Confermato";
        case "REJECTED":
            return "Rifiutato dall'utente";
        default:
            return ""
    }
}

export function getStatusColor(status) {
    if(!status) return "";

    switch (status) {
        case "CHECKINGOUT":
            return "grey1";
        case "PENDING":
            return "blue";
        case "ACCEPTED":
            return "green";
        case "DECLINED":
            return "red";
        case "CONFIRMED":
            return "green";
        case "REJECTED":
            return "red";
        default:
            return "-"
    }
}

export function getStatusHistoryString(status) {
    if (!status) return "";

    switch (status) {
        case "CHECKINGOUT":
            return "L'utente iniziato a creare la richiesta di preventivo";
        case "PENDING":
            return "L'utente ha inviato la richiesta di preventivo";
        case "ACCEPTED":
            return "La struttura ha accettato la richiesta di preventivo";
        case "DECLINED":
            return "La struttura ha rifiutato la richiesta di preventivo";
        case "CONFIRMED":
            return "L'utente ha confermato il preventivo";
        case "REJECTED":
            return "L'utente ha rifiutato il preventivo";
        default:
            return "";
    }
}

export function getPeopleString(details) {
    if(!details || !Array.isArray(details)) return ""
    return details
        .filter(({ key }) => ["adults", "children", "babies"].includes(key))
        .map(({ key, value }) => {
            let name;
            switch (key) {
                case "adults":
                    name = "Adulti";
                    break;
                case "children":
                    name = "Bambini";
                    break;
                case "babies":
                    name = "Neonati";
                    break;
                default:
                    name = "Persone";
            }
            return `${value} ${name}`;
        })
        .join(", ");
}